// extracted by mini-css-extract-plugin
module.exports = {"detailsWrapper":"PreviewItem_detailsWrapper__3EMrW","label":"PreviewItem_label__1p_y6","value":"PreviewItem_value__1CjqZ"};